/**
 * @typedef {Object} PartOrderMessage
 * @property {string}  id
 * @property {string}  partOrderId   - FK → partOrders.id
 * @property {'coordinator'|'contact'} sender
 * @property {string}  senderName    - 'You' for coordinator, contact's name for contact side
 * @property {string}  text
 * @property {string}  sentAt        - ISO timestamp
 */

/** @type {PartOrderMessage[]} */
export const partOrderMessages = [

  // ── INC10041 — Completed, FSL Atlanta (James Carver) ──────────────────────
  {
    id: 'msg-0001',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000001',
    sender: 'coordinator',
    senderName: 'You',
    text: 'Hi James — we have a part order for a 16-port KVM switch coming your way (INC10041). Can you confirm availability at FSL Atlanta?',
    sentAt: '2026-03-21T09:14:00.000Z',
  },
  {
    id: 'msg-0002',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000001',
    sender: 'contact',
    senderName: 'James Carver',
    text: 'Hey! Yes, we have 3 units on hand. Ready to pull and ship. What\'s the delivery address?',
    sentAt: '2026-03-21T09:31:00.000Z',
  },
  {
    id: 'msg-0003',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000001',
    sender: 'coordinator',
    senderName: 'You',
    text: 'Great — shipping to Pinnacle Insurance Group, 320 S Canal St, Chicago, IL 60606. SLA is March 26th.',
    sentAt: '2026-03-21T09:45:00.000Z',
  },
  {
    id: 'msg-0004',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000001',
    sender: 'contact',
    senderName: 'James Carver',
    text: 'Packed and handed off to carrier. Tracking number will be emailed. Should arrive by the 25th.',
    sentAt: '2026-03-22T11:03:00.000Z',
  },
  {
    id: 'msg-0005',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000001',
    sender: 'coordinator',
    senderName: 'You',
    text: 'Perfect, thank you James!',
    sentAt: '2026-03-22T11:18:00.000Z',
  },

  // ── INC10071 — Fulfilled, FSL Chicago (Priya Nair) ────────────────────────
  {
    id: 'msg-0006',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000004',
    sender: 'coordinator',
    senderName: 'You',
    text: 'Hi Priya — do you have a 48-port PoE switch (Part# SW-48P-POE) available at FSL Chicago? Need it for INC10071.',
    sentAt: '2026-03-24T13:05:00.000Z',
  },
  {
    id: 'msg-0007',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000004',
    sender: 'contact',
    senderName: 'Priya Nair',
    text: 'Checking now… yes, we have 2 in stock. Should I hold one for this order?',
    sentAt: '2026-03-24T13:22:00.000Z',
  },
  {
    id: 'msg-0008',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000004',
    sender: 'coordinator',
    senderName: 'You',
    text: 'Yes please, go ahead and hold it. I\'ll get the shipment created shortly.',
    sentAt: '2026-03-24T13:30:00.000Z',
  },

  // ── INC10092 — Completed, Supplier — Crestline Distribution (Tony Ferreira) ─────────
  {
    id: 'msg-0009',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000006',
    sender: 'coordinator',
    senderName: 'You',
    text: 'Tony, following up on PO-6007 for a 16Gbps Fibre Channel HBA. Can you confirm ship date?',
    sentAt: '2026-03-19T10:00:00.000Z',
  },
  {
    id: 'msg-0010',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000006',
    sender: 'contact',
    senderName: 'Tony Ferreira',
    text: 'Hi! PO-6007 is in our system. Stock is available and we\'re targeting a ship date of March 21st. I\'ll send tracking once it\'s out.',
    sentAt: '2026-03-19T10:47:00.000Z',
  },
  {
    id: 'msg-0011',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000006',
    sender: 'coordinator',
    senderName: 'You',
    text: 'Appreciate the quick update. Customer SLA is March 25th so that works. Thanks Tony.',
    sentAt: '2026-03-19T11:02:00.000Z',
  },
  {
    id: 'msg-0012',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000006',
    sender: 'contact',
    senderName: 'Tony Ferreira',
    text: 'Shipped! Tracking# 1Z999AA10123456784. Estimated delivery March 23rd.',
    sentAt: '2026-03-21T14:15:00.000Z',
  },
  {
    id: 'msg-0013',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000006',
    sender: 'coordinator',
    senderName: 'You',
    text: 'Got it, thank you!',
    sentAt: '2026-03-21T14:28:00.000Z',
  },
  {
    id: 'msg-0014',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000006',
    sender: 'contact',
    senderName: 'Tony Ferreira',
    text: 'Confirmed delivery to Ashford Capital Partners — signed and received on March 23rd. Let me know if anything else is needed on our end.',
    sentAt: '2026-03-23T16:05:00.000Z',
  },
];

// ─── Part Replenishment Messages ──────────────────────────────────────────────

/** @type {PartOrderMessage[]} */
export const partReplenishmentMessages = [

  // ── REP5001 — Active, Vantage Technology Supply (Rachel Simmons) — coordinator last ─
  {
    id: 'rep-msg-0001',
    replenishmentId: 'e4f5a6b7-0004-4000-8004-400000000001',
    sender: 'coordinator',
    senderName: 'You',
    text: 'Hi Rachel — we have a replenishment order REP5001 for 32GB DDR5 ECC DIMMs going to On-Site IBM Logistics. Can you confirm estimated ship date?',
    sentAt: '2026-03-22T08:30:00.000Z',
  },
  {
    id: 'rep-msg-0002',
    replenishmentId: 'e4f5a6b7-0004-4000-8004-400000000001',
    sender: 'contact',
    senderName: 'Rachel Simmons',
    text: 'Hi! Yes, we have those in stock. We can ship by March 25th. I\'ll get the order queued up on our end.',
    sentAt: '2026-03-22T09:15:00.000Z',
  },
  {
    id: 'rep-msg-0003',
    replenishmentId: 'e4f5a6b7-0004-4000-8004-400000000001',
    sender: 'coordinator',
    senderName: 'You',
    text: 'Perfect, thank you Rachel. Please ship to: 800 Congress Ave, Austin, TX. Attention: Marcus Webb.',
    sentAt: '2026-03-22T09:40:00.000Z',
  },

  // ── REP5002 — History, Crestline Distribution (Tony Ferreira) — contact replied last ──
  {
    id: 'rep-msg-0004',
    replenishmentId: 'e4f5a6b7-0004-4000-8004-400000000002',
    sender: 'coordinator',
    senderName: 'You',
    text: 'Tony, following up on REP5002 for the Fibre Channel HBAs. What\'s the status on that shipment?',
    sentAt: '2026-03-14T10:00:00.000Z',
  },
  {
    id: 'rep-msg-0005',
    replenishmentId: 'e4f5a6b7-0004-4000-8004-400000000002',
    sender: 'contact',
    senderName: 'Tony Ferreira',
    text: 'Just checked — RS8002 was delivered to East Coast Warehouse on March 13th and signed by Sandra Okafor. All 4 units confirmed received.',
    sentAt: '2026-03-14T10:32:00.000Z',
  },
  {
    id: 'rep-msg-0006',
    replenishmentId: 'e4f5a6b7-0004-4000-8004-400000000002',
    sender: 'coordinator',
    senderName: 'You',
    text: 'Excellent, marking this order as complete. Thanks Tony!',
    sentAt: '2026-03-14T10:45:00.000Z',
  },
  {
    id: 'rep-msg-0007',
    replenishmentId: 'e4f5a6b7-0004-4000-8004-400000000002',
    sender: 'contact',
    senderName: 'Tony Ferreira',
    text: 'Anytime! Let us know when the next order is ready — we can usually turn these around in 3–4 business days.',
    sentAt: '2026-03-14T11:02:00.000Z',
  },

  // ── REP5004 — Active, Vantage Technology Supply (Rachel Simmons) — coordinator last ─
  {
    id: 'rep-msg-0008',
    replenishmentId: 'e4f5a6b7-0004-4000-8004-400000000004',
    sender: 'coordinator',
    senderName: 'You',
    text: 'Rachel, REP5004 includes 3 NVMe SSDs and a KVM switch for Central Warehouse Dallas. Can you confirm all items are available?',
    sentAt: '2026-03-25T14:00:00.000Z',
  },
  {
    id: 'rep-msg-0009',
    replenishmentId: 'e4f5a6b7-0004-4000-8004-400000000004',
    sender: 'contact',
    senderName: 'Rachel Simmons',
    text: 'The NVMe SSDs are ready. The KVM switch has a 2-day lead time — I\'ll confirm once it\'s in.',
    sentAt: '2026-03-25T14:45:00.000Z',
  },
  {
    id: 'rep-msg-0010',
    replenishmentId: 'e4f5a6b7-0004-4000-8004-400000000004',
    sender: 'coordinator',
    senderName: 'You',
    text: 'Understood — let\'s hold the full shipment until everything is ready. No rush on the SLA for this one.',
    sentAt: '2026-03-25T15:05:00.000Z',
  },
];

// ─── Portal Ticket Messages (customer ↔ admin) ────────────────────────────────
// sender: 'contact'     = customer (portal user)   → right/teal bubble
// sender: 'coordinator' = logistics hub admin       → left/grey bubble

/** @type {PartOrderMessage[]} */
export const portalTicketMessages = [

  // ── INC10041 — Completed (Harborview / Jordan Tillman) ─────────────────────
  {
    id: 'portal-msg-0001',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000001',
    sender: 'contact',
    senderName: 'Jordan Tillman',
    text: 'Hi — just checking in on INC10041. Do you have an ETA on when the part will be delivered?',
    sentAt: '2026-03-21T10:05:00.000Z',
  },
  {
    id: 'portal-msg-0002',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000001',
    sender: 'coordinator',
    senderName: 'Logistics Support',
    text: 'Hi Jordan! We\'ve sourced the part from our Atlanta location and it\'s been handed off to the carrier. Estimated delivery is March 25th — ahead of your SLA.',
    sentAt: '2026-03-21T10:32:00.000Z',
  },
  {
    id: 'portal-msg-0003',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000001',
    sender: 'contact',
    senderName: 'Jordan Tillman',
    text: 'Great, thank you! Will I get a tracking number?',
    sentAt: '2026-03-21T10:45:00.000Z',
  },
  {
    id: 'portal-msg-0004',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000001',
    sender: 'coordinator',
    senderName: 'Logistics Support',
    text: 'Yes — tracking has been emailed to the address on file. The shipment has been marked as delivered. Please let us know if there are any issues!',
    sentAt: '2026-03-25T09:15:00.000Z',
  },

  // ── INC10132 — Open (Harborview / Jordan Tillman) ───────────────────────────
  {
    id: 'portal-msg-0005',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000010',
    sender: 'contact',
    senderName: 'Jordan Tillman',
    text: 'Hi, we submitted INC10132 for a PWR-7200-AC. Any update on the timeline? We have a critical system coming back online soon.',
    sentAt: '2026-03-29T14:20:00.000Z',
  },

  // ── INC10085 — Shipped (Greenfield Hospital Trust / Lisa Chen — Keystone IT Solutions) ──
  {
    id: 'portal-msg-0006',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000005',
    sender: 'contact',
    senderName: 'Lisa Chen',
    text: 'Hi team — following up on INC10085 for Greenfield Hospital Trust. Can you confirm the shipment is on its way?',
    sentAt: '2026-03-22T08:45:00.000Z',
  },
  {
    id: 'portal-msg-0007',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000005',
    sender: 'coordinator',
    senderName: 'Logistics Support',
    text: 'Hi Lisa — yes, SHP-30017 has been created and is en route from our Chicago FSL. Carrier is UPS and the tracking number has been emailed to you.',
    sentAt: '2026-03-22T09:15:00.000Z',
  },
  {
    id: 'portal-msg-0008',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000005',
    sender: 'contact',
    senderName: 'Lisa Chen',
    text: 'Perfect, thank you. Riverview needs this before the 23rd — looks like we\'re on track.',
    sentAt: '2026-03-22T09:30:00.000Z',
  },

  // ── INC10172 — Shipped (NovaStar Research Labs / Lisa Chen — Keystone IT Solutions) ────
  {
    id: 'portal-msg-0009',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000014',
    sender: 'contact',
    senderName: 'Lisa Chen',
    text: 'Hi — INC10172 is for a 3.84TB NVMe drive for NovaStar Research Labs. They need it for a storage expansion this week. What\'s the estimated delivery?',
    sentAt: '2026-03-27T11:00:00.000Z',
  },
  {
    id: 'portal-msg-0010',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000014',
    sender: 'coordinator',
    senderName: 'Logistics Support',
    text: 'Hi Lisa — the SSD has shipped from our East Coast Warehouse (SHP-30028, FedEx). Estimated delivery to NovaStar in Sarasota is March 30th — within your SLA.',
    sentAt: '2026-03-27T11:45:00.000Z',
  },
  {
    id: 'portal-msg-0011',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000014',
    sender: 'contact',
    senderName: 'Lisa Chen',
    text: 'Excellent. I\'ll let NovaStar know. Thanks for the quick turnaround!',
    sentAt: '2026-03-27T11:58:00.000Z',
  },

  // ── INC10188 — Awaiting Quote (NovaStar Research Labs / Lisa Chen — Keystone IT Solutions)
  {
    id: 'portal-msg-0012',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000016',
    sender: 'contact',
    senderName: 'Lisa Chen',
    text: 'We have a new request from NovaStar — they need a 16Gbps Fibre Channel HBA (INC10188). No stock at their site. What suppliers do you have for this?',
    sentAt: '2026-04-02T09:10:00.000Z',
  },
  {
    id: 'portal-msg-0013',
    partOrderId: 'c1a2b3d4-0001-4000-8001-100000000016',
    sender: 'coordinator',
    senderName: 'Logistics Support',
    text: 'Hi Lisa — we\'ve sent RFQs to our approved suppliers for the HBA-16G-FC. We should have quotes back within 24 hours. SLA is April 10th, so we have some runway.',
    sentAt: '2026-04-02T09:45:00.000Z',
  },
];
